<template>
  <div class="footer">
			<p>{{$t('footer')}} <img src="@/assets/images/fot.png" /></p>
			<div>
				<p>{{$t('jishuzhichi')}}</p>
				<a href="#">{{$t('map')}}</a>
			</div>
		</div>
  </div>
</template>

<script>
export default {
  name: 'foot',
  data() {
    return {
      
    }
  },
}
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/foot.vue